import React, { useState } from 'react';

import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import { ICourt } from '../../../Interfaces/ICourt';
import { IAdminstrativeUnit } from '../../../Interfaces/IAdminstrativeUnit';
import { ICourtRole } from '../../../Interfaces/ICourtRole';
import { ICourtAdminstrativeUnitAssignment } from '../../../Interfaces/ICourtAdminstrativeUnitAssignment';

interface IProps {
  court: ICourt;
  adminUnit: IAdminstrativeUnit;
  courtRoles: ICourtRole[];
  editCourtAdminUnitRoles: ICourtAdminstrativeUnitAssignment[];
  setEditCourtAdminUnitRoles: Function;
}

export const EditAdministrativeUnitCourtAsign: React.FC<IProps> = ({
  court,
  adminUnit,
  courtRoles,
  editCourtAdminUnitRoles,
  setEditCourtAdminUnitRoles,
}) => {
  const filteredCourtAdminUnitRoles = editCourtAdminUnitRoles.filter(
    editCourtAdminRole => editCourtAdminRole.idCourt === court.idCourt
  );
  const includedCourtRoles = filteredCourtAdminUnitRoles.map(
    courtAdminRole => courtAdminRole.idCourtRole
  );
  const filteredCourtRoles = courtRoles.filter(courtRole =>
    includedCourtRoles.includes(courtRole.idCourtRole)
  );
  //
  const [isOpenAdd, setIsOpenAdd] = useState(false);
  const [idCourtRole, setIdCourtRole] = useState<number | null>(null);

  const handleAddNew = () => {
    setIsOpenAdd(true);
    setIdCourtRole(null);
  };

  const handleRemoveMe = (
    foundCourtAdminUnit: ICourtAdminstrativeUnitAssignment
  ) => {
    setEditCourtAdminUnitRoles([
      ...editCourtAdminUnitRoles.filter(
        courtAdminUnitRole =>
          courtAdminUnitRole.idAssignment !== foundCourtAdminUnit.idAssignment
      ),
    ]);
  };

  const handleAdd = () => {
    let tmpId = -1;

    if (editCourtAdminUnitRoles.length > 0) {
      const tmpIdArray =
        Math.min(
          ...editCourtAdminUnitRoles.map(
            courtAdminUnit => courtAdminUnit.idCourtRole
          )
        ) - 1;

      if (tmpIdArray <= tmpId) {
        tmpId = tmpIdArray - 1;
      }
    }

    setEditCourtAdminUnitRoles([
      ...editCourtAdminUnitRoles,
      {
        idCourt: court.idCourt,
        idAdministrativeUnit: tmpId,
        idCourtRole: idCourtRole,
        activeAssignment: true,
      } as ICourtAdminstrativeUnitAssignment,
    ]);
    setIsOpenAdd(false);
  };

  return (
    <>
      {isOpenAdd && (
        <Dialog
          open
          onClose={() => setIsOpenAdd(false)}
          maxWidth='xs'
          fullWidth
        >
          <DialogContent>
            <Typography sx={{ mt: 4 }}>
              Bitte wählen Sie eine neue Rolle für das Gericht{' '}
              <b>{court.Court}</b>:
              <TextField
                //type="email"
                variant='outlined'
                label='Rolle'
                fullWidth
                value={idCourtRole === null ? '' : idCourtRole}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setIdCourtRole(Number(event.target.value));
                }}
                required
                select
                size='small'
              >
                {courtRoles.map(courtRole => (
                  <MenuItem
                    key={`select-courtroles-${courtRole.idCourtRole}`}
                    value={courtRole.idCourtRole}
                    disabled={includedCourtRoles.includes(
                      courtRole.idCourtRole
                    )}
                  >
                    {`${courtRole.CourtRole}`}
                  </MenuItem>
                ))}
              </TextField>
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={() => setIsOpenAdd(false)}>
              Abbruch
            </Button>
            <Button
              variant='contained'
              disabled={idCourtRole === null}
              onClick={handleAdd}
            >
              Hinzufügen
            </Button>
          </DialogActions>
        </Dialog>
      )}

      <Typography sx={{ mt: 4 }}>
        Das Gericht <b>{court.Court}</b> hat für die Gemarkung die folgende
        Rollen inne:
      </Typography>
      {filteredCourtRoles.map((courtRole, idx) => {
        const foundCourtAdminUnit = filteredCourtAdminUnitRoles.find(
          editCourtAdminRole =>
            editCourtAdminRole.idCourtRole === courtRole.idCourtRole
        );

        if (!foundCourtAdminUnit) {
          return (
            <Chip
              sx={{ mr: 1, mb: 1 }}
              color='error'
              label='Konnte Zuweisung nicht bestimmen!'
            />
          );
        } else {
          return (
            <Chip
              sx={{ mr: 1, mb: 1 }}
              color='success'
              variant='outlined'
              label={courtRole.CourtRole}
              onDelete={() => handleRemoveMe(foundCourtAdminUnit!)}
            />
          );
        }
      })}
      <Chip
        sx={{ mr: 1, mb: 1 }}
        color='warning'
        variant='outlined'
        label='Rolle hinzufügen'
        deleteIcon={<Add />}
        onDelete={handleAddNew}
      />
    </>
  );
};
